import { Theme } from "apps/website/maps/Theme.map";

export const getCardTheme = (theme: Theme) => {
  if ([ "brand", "light-grey", "green", "blue", "orange", "light" ].includes(theme)) return "dark";
  return "light-grey";
};
